import React from "react";
import { useParams } from "react-router-dom";
import CameraScanner from "../components/camera-scanner";

type ICodartParams = {
  code: string;
};

export const Codart: React.FC = () => {
  const { code } = useParams<ICodartParams>();
  // const navigate = useNavigate();
  React.useEffect(() => {
    // if (!id) {
    //   navigate("/sites");
    // }
  }, []);

  return (
    <div>
      <CameraScanner />
    </div>
  );
};
